module.exports = __webpack_public_path__ + "img/4gen-logistics-desktop.e7be7999.png";